module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp12_8023.6441f82e.png";